// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container--2nQXc"};